module.exports = __webpack_public_path__ + "img/icon_mall.4111d4be.png";